import {
  type Locale as MelwaysLocale,
  getLanguageFromLocale,
} from '@seek/melways-sites';

import hirerGraphqlClient from './client';
import type {
  JobInfoQuery,
  JobInfoQueryVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import queryGetJobDetails from './schema/queryJobInfo';

export const fetchHirerGraphJobInfo = async (
  advertiserId: string,
  jobId: string,
  locale: MelwaysLocale,
) => {
  const language = getLanguageFromLocale(locale);
  const { data } = await hirerGraphqlClient.query<
    JobInfoQuery,
    JobInfoQueryVariables
  >({
    variables: { advertiserId, jobId, language },
    query: queryGetJobDetails,
    fetchPolicy: 'cache-first',
  });

  return data;
};
